<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppStore } from '@/store/app';
import CustomersTable from '@/components/CustomersTable.vue';
import { DEFAULT_DATE } from '@/common/constants';

const store = useAppStore();
const router = useRouter();

onMounted(() => {
  store.fetchAllSubscriptionTypes();
  store.fetchAllBetMakersSubLevels();
  store.fetchAllBetMakersProducts();
  store.fetchAllUsers();
});

const onOpenCustomerTransaction = ({ customer }) => {
  if (customer?.subscriptionId === 0 && customer?.subscriptionStartDate === DEFAULT_DATE) return;
  router.push(`/all-customer-list/${customer?.id}`);
};
</script>

<script>
// normal `<script>`, executed in module scope (only once)
// declare additional options
export default {
  inheritAttrs: false,
  customOptions: {},
};
</script>

<template inheritAttrs="false">
  <div class="all-customers">
    <CustomersTable :customers="store.allCustomers" :rowAction="onOpenCustomerTransaction" />
  </div>
</template>

<style scoped lang="scss">
.all-customers {
  margin-top: 15px;
}
</style>
